if ($('.lity-hide')[0]) {
	document.addEventListener('lity:open', function (event, instance) {
		const video = document.querySelector('#lity-video');
		if (video) {
			video.play();
		}
	});

	document.addEventListener('lity:close', function (event, instance) {
		const video = document.querySelector('#lity-video');
		if (video) {
			video.pause();
			video.currentTime = 0;
		}
	});
}
